import { SitemapPageLazy } from './sitemapPageLazy';

const props = [];

export const SitemapPageDirective = reactDirective => reactDirective(SitemapPageLazy, props);
SitemapPageDirective.$inject = ['reactDirective'];

angular.module('WB.App').directive('sitemapPage', SitemapPageDirective);
